module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAADIBAMAAABolL7cAAAAJFBMVEXh4eGRkZGwsLCrq6uioqKXl5eUlJStra2np6elpaWampqenp4xM7NyAAAATElEQVRYw2NQUjfudNm1NCxRUFAwLXTVFs9mc6VhIMgAFBRgBAoyjAqOCo4KjgqOCo4KjgqOCo4KjgqOCo4KjgqOCg5uwUHYrSZbEADGTUx5u88m7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/split-panel/divide.png
// module id = 764
// module chunks = 0